import { DeleteOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import './style.less';

const UploadsPreview = ({ style, url, remove }) => {
  const { t } = useTranslation();

  return (
    <div className="upload-list-container" style={style}>
      <div className="upload-list-item">
        <div
          style={{
            height: '100%',
            padding: '0',
            transition: 'background-color .3s',
            backgroundImage: `url(${url})`,
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <Button
            icon={<DeleteOutlined />}
            danger
            onClick={remove}
            className="delete-btn"
            size="small"
          >
            {t('delete.text', 'Delete')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UploadsPreview;
